const activeSubscriptionStatus = ['active', 'trialing', 'past_due'];

export default activeSubscriptionStatus;
